import entertainmentIcon from '@/assets/img/icons/categories/entertainment-icon.svg'
import officeExpensesIcon from '@/assets/img/icons/categories/office-expenses-icon.svg'
import equipmentIcon from '@/assets/img/icons/categories/equipment-icon.svg'
import marketingIcon from '@/assets/img/icons/categories/marketing-icon.svg'
import mealsIcon from '@/assets/img/icons/categories/meals-icon.svg'
import otherIcon from '@/assets/img/icons/categories/other-icon.svg'
import phoneIcon from '@/assets/img/icons/categories/phone-icon.svg'
import softwareIcon from '@/assets/img/icons/categories/software-icon.svg'
import travelIcon from '@/assets/img/icons/categories/travel-icon.svg'

export const categoriesColors = [
  {
    id: 1,
    categoryName: 'Comidas y bebidas',
    color: '#fc8f2f',
    icon: mealsIcon
  },
  {
    id: 2,
    categoryName: 'Comunicaciones',
    color: '#790abb',
    icon: phoneIcon
  },
  {
    id: 3,
    categoryName: 'Equipación y Hardware',
    color: '#f17180',
    icon: equipmentIcon
  },
  {
    id: 4,
    categoryName: 'Formación o entretenimiento',
    color: '#5385d9',
    icon: entertainmentIcon
  },
  {
    id: 5,
    categoryName: 'Informática',
    color: '#5fcb7c',
    icon: softwareIcon
  },
  {
    id: 6,
    categoryName: 'Marketing y publicidad',
    color: '#0a756c',
    icon: marketingIcon
  },
  {
    id: 7,
    categoryName: 'Oficina',
    color: '#f73647',
    icon: officeExpensesIcon
  },
  {
    id: 8,
    categoryName: 'Otros',
    color: '#c69612',
    icon: otherIcon
  },
  {
    id: 9,
    categoryName: 'Viajes y transporte',
    color: '#0089f2',
    icon: travelIcon
  }

]
export const INCLUDE_IN_TRANSACTION_TYPES = {
  TRANSACTION: 'TRANSACTION',
  EXPENSE: 'EXPENSE',
  DIET: 'DIET',
  MILEAGE: 'MILEAGE'
}

export const COMPANIES_WITH_SPECIFIC_FEATURES = [
  { company: 'PLEXUS', id: 63 },
  { company: 'TWENTYFOUR_SEVEN', id: 418 },
  { company: 'TWENTYFOUR_SEVEN_CANARIAN', id: 500 },
  { company: 'SMILE_MEDIA', id: 498 },
  { company: 'TWENTYFOUR_SEVEN_PORTUGAL', id: 493 },
  { company: 'TALLERES_GARRIDO', id: 491 },
  { company: 'TWENTYFOUR_SEVEN_SEVEN_ISLAND_FILMS', id: 550 },
  { company: 'ROSA_GRES', id: 413 },
  { company: 'CATALONIA_CERAMICA', id: 412 },
  { company: 'TECNOCARROCERA', id: 560 }
]

export const TRANSACTION_TYPE_CODES = {
  NORMAL: 'NORMAL',
  EXPENSE: 'EXPENSE'
}

export const TRANSACTION_STATUS = {
  KO: 'KO',
  OK: 'OK',
  PENDING: 'PENDING'
}
export const EXPENSE_TYPES = {
  TRANSACTION: 'TRANSACTION',
  REIMBURSEMENT: 'REIMBURSEMENT',
  EXPENSE: 'EXPENSE',
  DIET: 'DIET',
  MILEAGE: 'MILEAGE'
}
// Usandose soo en filtros de transacción
export const RECEIPT_TYPES = {
  NONE: 'NONE',
  RECEIPT: 'RECEIPT',
  BILL: 'BILL'
}

export const TYPE_CODES = {
  NORMAL: 'NORMAL',
  EXPENSE: 'EXPENSE',
  BILL: 'BILL',
  ALL: 'ALL'
}

export const CUSTOM_EXPORT_SETTINGS_PER_COMPANY = [
  {
    officeId: 491,
    company: 'TALLERES_GARRIDO',
     exportSettingId: 42
    // exportSettingId: 53 ==> pruebas en dev
  },
  {
    officeId: 560,
    company: 'TECNOCARROCERA',
    exportSettingId: 70
  }
]

export const VALID_EXTENSIONS = ['.png', '.svg', '.jpg', '.jpeg']
